module.exports = __webpack_public_path__ + "img/R03v.937b8aaa.png";